// extracted by mini-css-extract-plugin
export default {"show_image":"Login_show_image__jO485","col_left":"Login_col_left__D5kRr","col_right":"Login_col_right__xWS6k","text_forgot":"Login_text_forgot__DJJqi"};